import api from "./api";

export async function fetchQuizFilterList(params = {}, endpoint = "/quiz/quiz-filter-list") {
  const response = await api.get(endpoint, {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}
